import React from 'react';
import { DISTRIBUTION_STATUS } from 'shared/constants/distribution';
import { Badge, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const { ACTIVE, SCHEDULED } = DISTRIBUTION_STATUS;

const DistributionStatusBadge = ({ status, showTooltip }) => {
  let color;

  switch (status) {
    case ACTIVE:
      color = 'success';
      break;
    case SCHEDULED:
      color = 'warning';
      break;
    default:
      color = 'error';
      break;
  }

  let badge = <Badge status={color} />;

  if (showTooltip && messages[status]) {
    badge = <Tooltip title={<FormattedMessage {...messages[status]} />}>{badge}</Tooltip>;
  }

  return badge;
};

export default DistributionStatusBadge;
